import React from 'react'

export const IconBurgerCollapse = (props={}) => {
	const { size=20, imgSize=8, strokeWidth=1.5 } = props
	const k = 14.0 / 8.0

	return <>
		<svg width={`${size}px`} height={`${k * size}px`} viewBox={`0 0 ${imgSize} ${k * imgSize}`} stroke="currentColor" fill="none" strokeWidth={strokeWidth} xmlns="http://www.w3.org/2000/svg">
			<path d="M7 13L1 7L7 1" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	</>
}
